import { typeaheadCheck } from '../utils';
import { productLinkBuilder } from 'common-next/src/components/common-functions';
import { RecommendedItem } from '../productCard/recommendedItem';
import type { GetSourcesParams, OnSelectParams } from '@algolia/autocomplete-core';
import type { BaseItem } from './types';

// Define the type for the recommendation item
interface RecommendationItem {
  productName: string;
  vintage: string;
  itemCode: string;
  giftFlag: boolean;
  productType: string;
  productWebType: string;
  country: string;
  grape: string;
  skus: any[];
}

const RecommendPluginHeader = () => <span className="aa-SourceHeaderTitle"> Recommended </span>;
const RecommendedPluginItem = ({ item, components }: any) => <RecommendedItem hit={item} components={components} />;

export function createRecommendPlugin() {
  return {
    getSources({ query: sourceQuery, state }: GetSourcesParams<BaseItem>) {
      if (!sourceQuery || !typeaheadCheck(sourceQuery)) {
        return [];
      }

      return [
        {
          sourceId: 'recommendPlugin',
          getItems() {
            const context = state.context as { topHit?: RecommendationItem };

            // Check if topHit exists in the context and return it for recommendations
            if (context?.topHit) {
              const { productName, vintage, itemCode, giftFlag, productType, productWebType, country, grape, skus } =
                context.topHit;

              return [
                {
                  productName,
                  vintage,
                  itemCode,
                  giftFlag,
                  productType,
                  productWebType,
                  country,
                  grape,
                  skus,
                },
              ];
            }

            // Fallback if no topHit is available
            return [];
          },
          onSelect({ item, state: selectState }: OnSelectParams<BaseItem>) {
            window.location.href = productLinkBuilder(
              item?.productName as string,
              item?.vintage as string,
              item?.itemCode as string,
              selectState.context.queryID?.toString() as string,
            );
          },
          templates: {
            header: RecommendPluginHeader,
            item: RecommendedPluginItem,
          },
        },
      ];
    },
  };
}
